module.exports = __webpack_public_path__ + "static/media/seta_esquerda.e2700608.svg";